/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import { GetBranchId } from '../../../../CommonMethods/GetBranchId';
import { dataService } from '../../../../services/data.services';
import SearchShimmer from '../../../../components/Shimmer/SearchShimmer';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import GlobalContext from '../../../../components/Context/GloablContext';

export default function Filter({
    FilterArray,
    selectedAYID,
    selectedClassID, 
    setSelectedAYID,
    setSelectedClassID,
    setSelectedSectionID,
    setSelectedExamID,
    setIsFilterOpen, 
    setSearchParams,
    handleClearFilter,
    handleApplyApi,
    selectedFilterParams, 
    setSelectedFilterParams,
    setSelectedAY,
    type,
    academicReports,
    pageType,
    searchParams}) {

    
    const [filterLoading, setFilterLoading] = useState(true);
    const {setToastErrorMessage} = useContext(GlobalContext)
    const [filters, setFilters] = useState(pageType === "staff" ? "financial_year" : 'academic_year');
    const navigate = useNavigate()

    const [allFilterData, setAllFilterData] = useState({
        academic_year : [],
        class : [],
        section : [],
        exam:[],
    });
    const [staffFilter, setStaffFilter] = useState({
        academic_year : [],
        employee_type : ["Teaching", "Non-Teaching"]
    })

    /**
     * The function `handleRadioButtonAction` updates the selected filter parameters based on the
     * selected item and the current filter type.
     */
    const handleRadioButtonAction = async (item, filters) => {
        if(filters === 'academic_year'){
            setSelectedAYID(item._id)
        }
        if(filters === 'class'){
            setSelectedClassID(item._id)
        }
        if(filters=== 'section'){
            setSelectedSectionID(item.section_id)
        }   
        if(filters=== 'exam'){
            setSelectedExamID(item.exam_id)
        }
        let updatedParams;
        if(pageType === "staff") {
            if (filters === "employee_type") {
                updatedParams = {
                    ...selectedFilterParams,
                    [filters]: item,
                }
            } else {
                updatedParams = {
                    ...selectedFilterParams,
                    [filters]: item.name,
                }
                setSelectedAY(item)
            }
        } else {
            if (filters === "section") {
                updatedParams = {
                    ...selectedFilterParams,
                    [filters]: item.section_name,
                };
            }
            else if (filters === "exam") {
                updatedParams = {
                    ...selectedFilterParams,
                    [filters]: item.exam_name,
                };
            }
            else {
                if(searchParams.get("academic_year") !== item.name) {
                    if(Object.keys(selectedFilterParams)?.length === 3) {
                        updatedParams = {
                            ...selectedFilterParams,
                            [filters]: item.name,
                            ["section"] : ""
                        };
                    } else {
                        updatedParams = {
                            ...selectedFilterParams,
                            [filters]: item.name,
                            ["section"] : "",
                            ["exam"] : ""
                        };
                    }
                
                } else {
                    updatedParams = {
                        ...selectedFilterParams,
                        [filters]: item.name,
    
                    };
                }
            
                if(Object.keys(selectedFilterParams)?.length === 3 && filters === "academic_year") {
                    setSelectedAY(item)
                }
            }
        }
        setSelectedFilterParams(updatedParams);
    }
    /* The above code is defining a function called `handelSelectedFilter` using the `useCallback`
    hook. This function is responsible for handling the selected filter and making an asynchronous
    API call based on the selected filter. */
    const handelSelectedFilter = useCallback(async () => {
        if(filters !== "employee_type"){
            let endPoint = "";
            const id = await GetBranchId();
            switch (filters) {
            case "academic_year":
                endPoint = `academic-years?filter=true&branch_id=${id}&status=ongoing,completed`
                break;
            case "financial_year":
                endPoint = `financial-years?filter=true&branch_id=${id}&status=open,closed,ongoing&sort=start_date%2Bdesc`
                break;
            case "class":
                endPoint = `classes?branch_id=${id}&sort=`+encodeURIComponent(`status+asc`); 
                break;
            case "section":
            case "exam" :
                endPoint = `associations?branch_id=${id}&academic_year_id=${selectedAYID}&class_id=${selectedClassID}&filter=true`
                break;
            default:
                break;
            }
            if(pageType === "staff") {
                endPoint = `${endPoint}&role=employees-attendance`
                try{
                    const res = await dataService.GetAPI(endPoint);
                    setStaffFilter((prev) => ({
                        ...prev,
                        [filters]: res.data.data.financial_years,
                    }));
                } catch (error){
                    setAllFilterData({
                        academic_year : [],
                        class : [],
                        section : [],
                        exam:[],
                    })
                    console.log(error)
                    setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
                }
            } else {
                if(filters === "exam" && allFilterData?.section?.length !== 0) {
                    allFilterData.section.forEach((item) => {
                        if(selectedFilterParams.section === item.section_name) {
                            setAllFilterData((prev) => ({
                                ...prev,
                                [filters]: item.exams,
                            }));
                        }
                    })
                } else if(allFilterData[filters]?.length === 0 || filters === "section" || filters === "exam") {
                    academicReports ? endPoint = `${endPoint}&role=academic-reports` : endPoint = `${endPoint}&role=students-attendance`
                    try{
                        const res = await dataService.GetAPI(endPoint);
                        setAllFilterData((prev) => ({
                            ...prev,
                            [filters]: res.data.data.data,
                        }));
                        if(filters === "exam") {
                            res.data.data.data.forEach((item) => {
                                if(selectedFilterParams.section === item.section_name) {
                                    setAllFilterData((prev) => ({
                                        ...prev,
                                        [filters]: item.exams,
                                    }));
                                }
                            })
                        }
                    } catch (error){
                        setAllFilterData({
                            academic_year : [],
                            class : [],
                            section : [],
                            exam:[],
                        })
                        console.log(error)
                        setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
                    }
                }
            }
            setFilterLoading(false);
        }
    }, [filters]);

    /**
     * The function `handleFilterValue` sets filters and updates filter loading based on the selected
     * filter parameters.
     */
    const handleFilterValue = (filter) => {
        if(filters !== filter) {
            switch (filter) {
            case "financial_year":
            case "academic_year":
            case "employee_type":
                setFilters(filter)
                //setFilterLoading(true)
                break;
            case "class":
                if(selectedFilterParams.academic_year !== "") {
                    setFilters(filter)
                    setFilterLoading(true)
                }
                break;
            case "section":
                if(selectedFilterParams.academic_year !== "" && selectedFilterParams.class !== "") {
                    setFilters(filter)
                    setFilterLoading(true)
                }
            case "exam":
                if(selectedFilterParams.academic_year !== "" && selectedFilterParams.class !== "" && selectedFilterParams.section !== "") {
                    setFilters(filter)
                    setFilterLoading(true)
                }
                break;
            default:
                break;
            }
        }
        
    }

    /* The above code is defining a function called `getAppliedFilterFromParams` using the
    `useCallback` hook in React. This function is responsible for extracting filter parameters from
    the `searchParams` object and updating the `selectedFilterParams` state. */
    const getAppliedFilterFromParams = useCallback(() => {
        if(Object.keys(selectedFilterParams)?.length === 2) {
            setSelectedFilterParams({
                financial_year: searchParams.get("financial_year") !== null ? searchParams.get("financial_year") : "",
                employee_type: searchParams.get("employee_type") !== null ? searchParams.get("employee_type") : "",
            });
        } else if(Object.keys(selectedFilterParams)?.length === 3) {
            setSelectedFilterParams({
                academic_year: searchParams.get("academic_year") !== null ? searchParams.get("academic_year") : "",
                class: searchParams.get("class_name") !== null ? searchParams.get("class_name") : "",
                section: searchParams.get("section_name") !== null ? searchParams.get("section_name") : "",
            });
        } else {
            setSelectedFilterParams({
                academic_year: searchParams.get("academic_year") !== null ? searchParams.get("academic_year") : "",
                class: searchParams.get("class_name") !== null ? searchParams.get("class_name") : "",
                section: searchParams.get("section_name") !== null ? searchParams.get("section_name") : "",
                exam: searchParams.get("exam") !== null ? searchParams.get("exam") : "",
            });
        }
    }, [searchParams]);

    /* The above code is using the useEffect hook in React to call the function
    getAppliedFilterFromParams when the component is mounted or when the getAppliedFilterFromParams
    function changes. */
    useEffect(() => {
        getAppliedFilterFromParams()
    }, [getAppliedFilterFromParams])

    /* The above code is using the useEffect hook in React to call the `handelSelectedFilter` function.
    It is specifying that the effect should be triggered whenever the `handelSelectedFilter`
    function changes. */
    useEffect(() => {
        handelSelectedFilter()
    }, [handelSelectedFilter])
    /**
     * The function `handleApplyFilter` sets loading state, updates search parameters, closes the
     * filter, checks if any filter values are empty, and makes an API call with the selected filter
     * parameters.
     * @returns The function handleApplyFilter is returning nothing (undefined).
     */
    const handleApplyFilter = async () => {
        setIsFilterOpen(false);
    
        // Check if the page type is "staff" and only `financial_year` is required
        if (pageType === 'staff') {
            if (!selectedFilterParams.financial_year) {
                return; // Don't proceed if `financial_year` is empty or undefined
            }
        } 
        // For other page types, check if any value in `selectedFilterParams` is empty
        else if (Object.values(selectedFilterParams).some(value => value === '')) {
            return; // Don't proceed if any field is empty
        }
    
        handleApplyApi();
    };

    /**
     * The handleClear function clears the filters and calls the handleClearFilter function.
     */
    const handleClear = () => {
        setFilters('academic_year');
        handleClearFilter()
    }

    /**
     * The function `filterButtonUrl` takes a type parameter and returns either a URL or a name based
     * on the value of the filters parameter.
     * @returns The function `filterButtonUrl` returns either the `url` or the `name` based on the
     * value of the `type` parameter.
     */
    const filterButtonUrl = (type) => {
        let url = ""
        let name = ""
        switch (filters) {
        case "academic_year":
            url = "/manage-academic-years/add-new-academic-year"
            name = `${filters.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}`
            break;
        case "class":
            url = "/main-hub/classes/add-class"
            name = `${filters.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}`
            break;
        case "section":
        case "exam":
            url = "/employee-master/manage-association/add-association"
            name = `Class Association`
            break;
        default:
            break;
        }
        return type === "url" ? url : name
    }

    const isButtonDisabled = () => {
        if (pageType === 'staff') {
            // Disable button only if `financial_year` is empty for staff
            return !selectedFilterParams.financial_year;
        }
        // For other page types, disable button if any field is empty
        return Object.values(selectedFilterParams).some(value => value === '');
    };

    return (
        <>
            <div className={`filter_btn_drp_dwn ${pageType === "staff" ? "top4" : "top1"} shadow-s1 filter_modal`} style={{'width':'350px'}}>
                <div className="flex">
                    <ul className="flex list-none flex-col flex-wrap h-fit min-w-[115px] filter_btn_drp_dwn_div1" role="tablist" data-te-nav-ref>
                        {FilterArray.map((item) => (
                            <li role="presentation" className="flex-grow text-center" key={item}>
                                <button
                                    id ={item}
                                    onClick={() => { handleFilterValue(item.toLowerCase().replace(/ /g, "_")); }}
                                    className={`text-start relative block text-sm font-normal ${filters === item.toLowerCase().replace(/ /g, "_") ? ' text-[#106EB4]' : 'text-[#4D555B]'} mb-3`}
                                >{item}
                                </button>
                            </li>
                        ))}
                    </ul>
                    <div className={`${pageType === "staff" ? "h-[165px]" : "h-[220px]"} filter_btn_drp_dwn_div2`}>
                        
                        <div
                            className={` opacity-1 transition-opacity duration-150 data-[te-tab-active]:block ease-linear`}
                            id="tabs-home13"
                            role="tabpanel"
                            aria-labelledby="tabs-home-tab13">
                            {filterLoading ?
                                <SearchShimmer />
                                :
                                <>{ (pageType === "staff" ? (staffFilter[filters] && staffFilter[filters]?.length === 0) : (allFilterData[filters] && allFilterData[filters]?.length === 0 ))?
                                    <div className={`${pageType === "staff" ? "h-[160px]" : "h-[220px]"} flex flex-col justify-center empty_card_section`}>
                                        <p className="text-[13px] text-center">No options available. Click on the below button to add necessary details.</p>
                                        <button onClick={() => navigate(filterButtonUrl("url"))} type="button" className="px-1.3 py-0.5 border border-[#106EB4] rounded mt-2 mx-auto w-[85%]">
                                            <span className="text-sm  text-[#106EB4] add_acadamic_year">Add {filterButtonUrl("name")}</span>
                                        </button>
                                    </div>
                                    
                                    :
                                    <div className={`${pageType === "staff" ? "h-[160px]" : "h-[215px]"} overflow-auto scroll-smooth scroll-bar acadamic_year_content`}>
                                        {pageType === "staff" ?
                                            (staffFilter[filters] && staffFilter[filters]?.map((item, index) => (
                                                <div onChange={() => handleRadioButtonAction(item, filters)} key={item._id} className="relative custom-radioBlue mb-3 flex items-center">
                                                    <input
                                                        id={`class-radio-${index}`}
                                                        type="radio"
                                                        name="default-radio1"
                                                        checked={filters === "employee_type" ? item === selectedFilterParams[filters] : item.name === selectedFilterParams[filters]}
                                                    />
                                                    <label 
                                                        htmlFor={`class-radio-${index}`} 
                                                        title={filters === "financial_year" ? `${item.name} (${moment.utc(item.start_date).format("MMM DD, YYYY")}-${moment.utc(item.end_date).format("MMM DD, YYYY")}) (${item?.status.charAt(0).toUpperCase() + item?.status.slice(1)})`: item}
                                                        className="">{filters === "employee_type" ? item : `${item.name} (${item?.status.charAt(0).toUpperCase() + item?.status.slice(1)})`}</label>
                                                </div>
                                            )))
                                            :
                                            (allFilterData[filters] && allFilterData[filters]?.map((item, index = 0) => (
                                                <div onChange={() => handleRadioButtonAction(item, filters)} key={item._id} className="relative custom-radioBlue mb-3 flex items-center">
                                                    <input
                                                        id={`class-radio-${index}`}
                                                        type="radio"
                                                        name="default-radio1"
                                                        checked={filters === "exam" ? item.exam_name === selectedFilterParams[filters] : filters === "section" ? item.section_name === selectedFilterParams[filters] : item.name === selectedFilterParams[filters]}
                                                    />
                                                    <label 
                                                        htmlFor={`class-radio-${index}`} 
                                                        title={filters === "exam" ? item.exam_name : filters === "section" ? item.section_name : filters === "academic_year" ? `${item.name} (${moment.utc(item.start_date).format("MMM DD, YYYY")}-${moment.utc(item.end_date).format("MMM DD, YYYY")}) (${item.status})`: item.name}
                                                        className="">{filters === "exam" ? item.exam_name : filters === "section" ? item.section_name : (filters === "academic_year" ? `${item.name} (${item.status.charAt(0).toUpperCase() + item.status.slice(1)})` : item.name+""+(item.status?'':' (Inactive)'))}</label>
                                                </div>
                                            )))}
                                    </div>
                                }</>}
                        </div>
                        
                    </div>
                </div>
                <div className="flex items-center justify-center pt-[10px] mt-1 shadow-top">
                    <button
                        type="button"
                        className="clr-btn"
                        onClick={() => handleClear()}
                    >
                        Clear All
                    </button>
                    <button
                        id = "apply_filter"
                        onClick={() => handleApplyFilter()}
                        type="button"
                        className={`aply-fltr-btn`}
                        disabled={isButtonDisabled()}
                    >Apply Filter(s)
                    </button>
                </div>
            </div>
        </>
    )
}
